export const useFileUpload = () => {
  const getMetadata = (res: {file: any}) => {
    const file = res?.file;
    // console.log('file', file)
    const filename = file.meta.filename;
    const contentType = file.meta.type;
    const size = file.meta.size;
  
    const uploadUrl = file.tus.uploadUrl || file.meta.url;
    const match = uploadUrl.match(/files\/([a-zA-Z0-9]+)\+/);
    const S3Key = match ? match[1] : null;
    const panel_id = file.meta.panel_id;
    return { 
      filename, 
      content_type: contentType, 
      size, 
      s3_key: S3Key, 
      url: uploadUrl,
      panel_id
    };
  }

  return {
    getMetadata
  }
} 